export default __webpack_public_path__ + "static/media/client3.177f8705.jpeg";